<template>
   <div>
       <div class="container-fluid">
           <div class="management-services-header">
               <div id="ms-header-bg"></div>
               <div class="header-text">
                   <p>
                        Evolving into a market leader<br>
                        by supplying quality products<br> 
                        while combining excellent<br>
                        service and valued pricing. 
                   </p>
               </div> 
           </div>
 
           <div class="mobile-img-header">
               <div>
                   <div style="background-image:url('../../public/images/about-us-3.jpg');background-size:cover;background-repeat:no-repeat;width:100%;height:0;padding-top:52vh;position:relative;"></div>
                   <div class="mobile-header-text">
                       <p>
                            Evolving into a market leader<br>
                            by supplying quality products<br> 
                            while combining excellent<br>
                            service and valued pricing. 
                       </p>
                   </div>
               </div>
           </div>
       </div>
 
       <div class="container-fluid cont">
           <div class="management-services-content">
               <div class="management-services-content-left" id="desktop-img-wrapper">
                   <div id="services-imgs">
                       <img src="../../public/images/management-services-img1.png">
                       <img src="../../public/images/management-services-img2.png">
                   </div>
               </div>
               <div class="management-services-content-right">
                   <!-- <h2 id="services-title" style="margin-bottom:30px;">The Synergy Way</h2> -->
                   <div id="mobile-img-wrapper"></div>
                   <!-- <p style="font-weight:bold;font-size:24px">Management Services – Keys to delivering success</p> -->
                   <p id="services-text">
                       <strong>Synergy’s Mission:</strong> To ensure high quality procurement solutions that enable clients to meet
their business goals more effectively. We emphasize communication and quality employee
enablement while performing as an ethical and professional organization<br><br>
                        Synergy International Metals (SIM) has a unique character that has made the company
successful by managing its supply base from the South Korea to it Western clientele. The
leadership team of Synergy is a melting pot of culturally sensitive Westerners and Asians who
have lived in Asia for over 30 years. SIM’s directors have spent over 40 years of combined
experience in Supply Chain and Senior Management roles across Asia allowing them to
establish and develop the unique model in which the company thrives. Our factors for
success extend to having a firm understanding of current market conditions, social customs,
and economic drivers of both regions.<br><br>
                    <span class="has-box-text">To find out more about the Synergy advantage visit our profile page: </span>
                    <router-link to="/profile" style="display:inline-block;margin-bottom:25px;">
      <div class="btn-group-lg" style="display:inline-block;">
        <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Profile</button>
        <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
      </div>
    </router-link><br>
                    <span class="has-box-text">Or visit our Linked In profile:</span> 
                    <a href="https://www.linkedin.com/in/art-lozano-ba07b5174" target="_blank" style="display:inline-block;">
      <div class="btn-group-lg" style="display:inline-block;margin-bottom:25px;">
        <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">Visit our LinkedIn</button>
        <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
      </div>
    </a>
    <span class="has-box-text">Or send us a message by contacting us using the information below.</span>
                   </p>
               </div>
           </div>
       </div>
   </div>
</template>
 
<script>
import $ from 'jquery';
 
export default {
   name: "ManagementServices",
   head: {
      script: [
        { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=G-LR5GK795VW', async: true, body: false}, // Insert in bod
      ],
    },
   mounted() {
       $(function(){
           MoveSearch(x);
       });
       var x = window.matchMedia("(max-width: 900px)")
       x.addListener(MoveSearch)
       function MoveSearch(x) {
           if (x.matches) {
               $('#services-imgs').appendTo('#mobile-img-wrapper');

            //    $('#services-imgs2').prependTo('#mobile-img-wrapper2');
            //    $('#services-imgs2').append('<div class="clearfix"></div>');
           } else {
               $('#services-imgs').appendTo('#desktop-img-wrapper');

            //    $('#services-imgs2').appendTo('#desktop-img-wrapper2');
           }
       }
   }
}
 
 
$(function(){
   MoveSearch(x);
});
 
var x = window.matchMedia("(max-width: 900px)")
x.addListener(MoveSearch)
 
function MoveSearch(x) {
 if (x.matches) {
   $('#services-imgs').appendTo('#mobile-img-wrapper');
   $('#services-imgs2').prependTo('#mobile-img-wrapper2');
   $('#services-imgs2').append('<div class="clearfix"></div>');
 } else {
   $('#services-imgs').appendTo('#desktop-img-wrapper');
   $('#services-imgs2').appendTo('#desktop-img-wrapper2');
 }
}
 
   window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-LR5GK795VW');
</script>
 
<style scoped>
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       font-family: 'Forma DJR Micro', sans-serif;
   }
   .cont {
       padding: 0 7% 0 7%;
   }
   .has-box-text{
       display: block;
    font-size: 17px;
    line-height: 32px;
    margin: 25px 0 15px 0;
    text-align: left;
 }
   .management-services-header {
       background: url("../../public/images/about-us-3.jpg");
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
   }
   #ms-header-bg {
       background-image:url('../../public/images/about-us-3.jpg');
       background-size: cover;
       background-repeat:no-repeat;
       width:100%;
       height:0;
       padding-top:35%;
       position:relative;
       visibility: hidden;
   }
   #header-gDash {
       width:49%;
       max-width:1080px;
       height:3px;
       background:#00C5BC;
       position:absolute;
       bottom:17%;
   }
   .header-text, .mobile-header-text {
       position: absolute;
       top: 0;
       padding: 110px 4% 0 0;
       width: 100%;
   }
   .header-text p {
       color: white;
       font-size: clamp(35px, 3.3vw, 65px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-header-text p {
       color: white;
       font-size: clamp(20px, 12vw, 50px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-img-header {
       background: url("../../public/images/about-us-3.jpg") bottom;
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       display: none;
   }
   #services-title {
       font-size: 40px;
       line-height: 60px;
       font-weight: bold;
   }
   .package-services-content {
       margin-top: 6%;
   }
   .package-services-content-left, .package-services-content-right {
       width: 50%
   }
   .package-services-content-left img {
       height: auto;
       display: block;
   }
   .package-services-content {
       margin-top: 6%;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
   }
   .management-services-content-left, .management-services-content-right {
       width: 50%
   }
   .management-services-content-left img {
       width: 85%;
       height: auto;
       display: block;
       margin-bottom: 50px ;
   }
   .management-services-content {
       margin-top: 10%;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
   }
   .about-content-right-subbox {
       background: #004884;
       width: 100%;
       padding: 5%;
       color: white;
       font-size: 24px;
       font-weight: thin;
       margin: 6% 0 8% 0;
   }
   #mobile-management-header {
       margin: 50px 0 0 0;
       font-size: 30px;
       line-height: 50px;
       margin-bottom: 30px;
       font-weight: bold;
   }
   #mobile-subbox {
       background: #004884;
       width: 100%;
       padding: 9%;
       color: white;
       font-size: clamp(20px, 1.5vw, 40px);
       font-weight: thin;
       margin: 15px 0 50px 0;
   }
   #mobile-management-content {
       display: none;
   }
   .nxt-btn-box {
       background: #00C5BC;
       border-radius: 0;
       border: none;
       font-size: 17px;
       padding: 10px 21px;
   }
   .nxt-btn-arrow {
       background: #79D9D5;
       border-radius: 0;
       border: none;
       font-size: 17px;
       padding: 10px 13px;
   }
   #services-text {
       font-size: 17px;
       line-height: 32px;
       text-align: justify;
   }
   .simg1 {
       width: 82%;
       margin: 0 0 4% 0;
   }
   .simg2 {
       width: 39%;
       float: left;
   }
   @media screen and (max-width: 1200px) {
       #header-gDash {
           width:44%;
       }
   }
   @media screen and (max-width: 1100px) {
       #header-gDash {
           width:40%;
       }
   }
   @media screen and (max-width: 1000px) {
       #header-gDash {
           width:35%;
       }
   }
   @media screen and (max-width: 900px) {
       .cont {
           padding: 0 50px 60px 50px;
       }
       .management-services-header {
           display: none;
       }
       .mobile-img-header {
           display: block;
       }
       #mobile-management-bot {
           margin-bottom: 50px;
       }
       .header-text, .mobile-header-text {
      padding: 100px 4% 0 0;
    }
    .package-services-content {
           flex-direction: column;
       }
       .package-services-content-right-subbox {
           width: 100vw;
           position: relative;
           left: calc(-50vw + 50%);
           padding: 9%;
           color: white;
           font-size: clamp(20px, 1.5vw, 24px);
           font-weight: thin;
           margin: 15px 0 50px 0;
       }
       #mobile-img-wrapper, .package-services-content-right {
           width: 100%;
       }
       .simg1 {
           width: 100%;
       }
       .simg2 {
           width: 48%;
       }
   .mobile-header-text p {
     font-size: clamp(20px,7vw,40px);
   }
       .management-services-content {
           flex-direction: column;
           display: block;
       }
       #mobile-img-wrapper, .management-services-content-right {
           width: 100%;
       }
       #mobile-img-wrapper img {
           width: 100%;
           max-width: 550px;
           height: auto;
           display: block;
           margin: 0 auto 40px auto;
       }
       .about-content-right-subbox {
           width: 100vw;
           position: relative;
           left: calc(-50vw + 50%);
           padding: 9%;
           color: white;
           font-size: clamp(20px, 1.5vw, 24px);
           font-weight: thin;
           margin: 15px 0 50px 0;
       }
       #services-title {
           font-size: 35px;
       }
   }
   @media screen and (max-width: 630px) {
       .mobile-header-text p {
           font-size: clamp(25px,6vw,35px);
       }
   }
   @media screen and (max-width: 500px) {
       .cont {
           padding: 0 20px 50px 20px;
       }
       .mobile-img-header {
           max-height:335px;
       }
       .has-box-text{
    font-size: 16px;
    line-height: 30px;
 }
       #mobile-management-header {
           font-size: 27px;
           line-height: unset;
       }
       .mobile-header-text p {
           font-size: clamp(25px,6vw,35px);
       }
       .nxt-btn-box, .nxt-btn-arrow {
           font-size: 14px;
       }
       #mobile-subbox {
           font-size: 20px;
       }
       #services-text {
           font-size: 16px;
           line-height: 30px;
       }
       #services-title {
           font-size: 26px;
           line-height: 42px;
       }
       .about-content-right-subbox {
           font-size: 20px;
       }
   }
   @media screen and (max-width: 335px) {
       .mobile-header-text p {
           font-size: 24px;
           line-height: 1.25em;
       }
   }
   /* @media screen and (max-width: 290px) {
       .mobile-img-header {
           margin-top:-30%;
       }
   } */
</style>
 

